import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Hook to detect if the current screen width is mobile (< 768px)
 * Returns true for mobile screen sizes, false for larger screens
 */
export function useIsMobileScreen(t0) {
  const $ = _c(3);
  const breakpoint = t0 === undefined ? 768 : t0;
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== breakpoint) {
    t1 = () => {
      setIsMobileScreen(window.innerWidth < breakpoint);
      let timeoutId;
      const checkIsMobileScreen = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          setIsMobileScreen(window.innerWidth < breakpoint);
        }, 150);
      };
      window.addEventListener("resize", checkIsMobileScreen);
      return () => {
        clearTimeout(timeoutId);
        window.removeEventListener("resize", checkIsMobileScreen);
      };
    };
    t2 = [breakpoint];
    $[0] = breakpoint;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return isMobileScreen;
}